<template>
    <div class="right-modal-wrap">
        <div v-show="dataShow" @click="dataShow = false" class="bg-effect"></div>
        <div :class="['right-modal',{'show': dataShow}]">
            <slot></slot>
            <svg @click="dataShow = false"
                 v-show="dataShow"
                 class="close-icon"
                 width="18px"
                 height="18px"
                 fill="var(--lighten-7-color)">
                <use xlink:href="../../assets/images/sprite.svg#close-x"></use>
            </svg>
        </div>
    </div>
</template>

<script>

    export default {
        name: "right-modal",
        data() {
            return {
                dataShow: false
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.dataShow = this.show;
        },
        methods: {

        },
        watch: {
            show(val) {
                this.dataShow = val
            },
            dataShow(val) {
                if (val) {
                    document.getElementsByTagName("html")[0].style.overflowY = "hidden";
                } else {
                    document.getElementsByTagName("html")[0].style.overflowY = "auto"
                }
                this.$emit("toggle", val)
            }
        }
    }
</script>

<style scoped>
    .right-modal-wrap .right-modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: var(--white-color);
        z-index: 100;
        transform: translateX(100%);
        transition: all .4s ;
    }
    .right-modal-wrap .bg-effect {
        z-index: 100;
    }
    .right-modal-wrap .right-modal.show {
        transform: translateX(0);
    }
    .right-modal-wrap .right-modal .close-icon {
        position: absolute;
        top: 18px;
        right: 18px;
        transition: all .2s;
        cursor: pointer;
    }
    .right-modal-wrap .right-modal .close-icon:hover {
        fill: #313131;
    }
</style>
